module.exports = "/_next/static/images/video_id_7104712733639232814-4c6a98008a9c2c5b2b669eb8a5fea272.jpg";